export default __webpack_public_path__ + "static/media/drake.c3c70583.png";